import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { InputNumber } from "@loanbossinc/component-library";

export const StyledIconButton = styled(IconButton)`
  && {
    background: ${props => (props.isSelected ? "#005AA9" : "none")};
    border-color: #005aa9;
    border: 1px solid;
    box-sizing: border-box;
    color: ${props => (props.isSelected ? "#FFFFFF" : "#005AA9")};
    font-size: 1.5rem;
    height: 28px;
    margin: 0 3px;
    width: 28px;
  }
`;

export const FieldWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const FieldLeftContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 53%;
  }
`;

export const FieldIconWrapper = styled.div`
  && {
    padding: 0 1em;
  }
`;

export const FieldNameTypeWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const RemoveWrapper = styled.div`
  && {
    color: #005aa9;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const FieldRightContentWrapper = styled.div`
  && {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    padding: 0 1em;
    text-align: right;
    width: 47%;
  }
`;

export const FieldLevelWrapper = styled.div`
  && {
    color: #005aa9;
    font-size: 14px;
    font-weight: 500;
    padding-right: 1em;
  }
`;

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9;
  }
`;

export const DescriptionWrapper = styled.div`
  && {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    padding-right: 0.7em;
  }
`;

export const OperationsWrapper = styled.div`
  && {
    align-items: center;
    border-bottom: 1px solid #dadce0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 0 1em 0.5em;
  }
`;

export const SectionWrapper = styled.div`
  && {
    align-items: flex-start;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    display: flex;
  }
`;

export const LeftSectionWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-left: 0.5em;
    width: 50%;
  }
`;

export const HousesIconWrapper = styled.div`
  && {
    padding-left: 0.6em;
  }
`;

export const RightSectionWrapper = styled.div`
  && {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    padding-left: 0.5em;
    width: 50%;
  }
`;

export const InputWrapper = styled.div`
  && {
    margin-bottom: 1em;
    width: 100%;
  }
`;

export const ControlRow = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0.5em;
  }
`;

export const ControlRowItem = styled.div`
  && {
    padding: 0 0.5em;
    width: 100%;
  }
`;

export const ResultTextWrapper = styled.div`
  && {
    font-family: "Work Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const CalcResultWrapper = styled.div`
  min-width: 220px;
  padding: 0 1em;
  height: 45px;
  background: #fafafa;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: right;
`;

export const RightAlignedInputNumber = styled(InputNumber)`
  && {
    .MuiInputBase-input {
      text-align: right !important;
    }
  }
`;
